import {
  type IconButtonProps as ChakraIconButtonProps,
  type RecipeVariantProps,
  useRecipe,
} from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/molecules/Tooltip';
import type { buttonRecipe } from '@shared/chakra/themeSettings/recipes';
import * as React from 'react';

export type IconButtonProps = ChakraIconButtonProps &
  RecipeVariantProps<typeof buttonRecipe> & {
    /**
     * Optional tooltip content for the button.
     * Kept as a distinct prop name to avoid collisions with other components' `tooltip` props.
     */
    tooltipContent?: React.ReactNode;
  };

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(props, ref) {
    const { tooltipContent, ...rest } = props;
    const recipe = useRecipe({ key: 'button' });
    const [recipeProps, restProps] = recipe.splitVariantProps(rest);

    const styles = recipe(recipeProps);

    const button = <ChakraIconButton ref={ref} css={styles} {...restProps} />;

    if (tooltipContent != null && tooltipContent !== '') {
      return <Tooltip content={tooltipContent}>{button}</Tooltip>;
    }

    return button;
  }
);
